// extracted by mini-css-extract-plugin
export default {"root":"default-page-template_root__WbjOF"};